import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['6 horas buscando actividades que nunca quedan bien', 'Planificaciones armadas la noche anterior, a las corridas', '30 cuadernos para corregir cada fin de semana', 'Gestión de aula, conducta y evaluación sin protocolo', 'Mensajes de padres en el teléfono los domingos', 'El mismo ciclo, el próximo año, sin salida'];
export function Problem() {
  return <section className="bg-white px-4 py-14" data-id="element-172">
      <div className="mx-auto max-w-3xl" data-id="element-173">
        <h2 className="text-center font-display text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-174">
          ¿Cuántos domingos más vas a perder así?
        </h2>
        <div className="mx-auto mt-5 max-w-2xl space-y-4 text-center text-[15px] leading-relaxed text-navy/70 sm:text-base" data-id="element-175">
          <p data-id="element-176">
            Eres docente. Amas enseñar. Pero nadie te dijo que ibas a pasar 6
            horas cada domingo buscando actividades que nunca encajan, armando
            evaluaciones a la noche y llegando al lunes con material que “más o
            menos sirve”.
          </p>
          <p className="font-semibold text-navy" data-id="element-177">
            Eso es 240 horas de tu vida al año. Perdidas. Sin recuperación.
          </p>
          <p className="font-display text-lg font-bold italic text-magenta" data-id="element-178">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <p className="mt-10 text-center text-sm font-bold uppercase tracking-wide text-navy/55" data-id="element-179">
          Lo que vive el 90% de los maestros cada semana:
        </p>
        <ul className="mx-auto mt-5 grid max-w-2xl gap-3" data-id="element-180">
          {pains.map(p => <li key={p} className="flex items-start gap-3 rounded-xl border border-magenta/15 bg-magenta/5 px-4 py-3" data-id="element-181">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-magenta text-white" data-id="element-182">
                <XIcon className="h-4 w-4" data-id="element-183" />
              </span>
              <span className="text-[15px] font-medium text-navy/80" data-id="element-184">{p}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-xl font-black text-navy sm:text-2xl" data-id="element-185">
          ¿Y si este fuera el último domingo que pasas así?
        </p>
      </div>
    </section>;
}